<template>
    <div>
        <nav class="navbar container ls-main-nav">
            <div class="navbar-brand">
                <a href="/" class="navbar-item">

                    <img src="../img/MM11.png" srcset="../img/MM11.png 320w, ../img/MM11.png 400w, ../img/MM11.png 1024w" title="Minute Merge" width="300">
                     <!--<img src="../img/bulma-style.png" srcset="../img/bulma-style@2x.png 320w, ../img/bulma-style@3x.png 400w, ../img/bulma-style@3x.png 1024w" title="LandSpeed BulmaStyle" width="300">-->
                </a>
                <a role="button" class="navbar-burger has-text-info" data-target="mainNavMenu" aria-label="menu" aria-expanded="false">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div class="navbar-menu" id="mainNavMenu">
                <div class="navbar-end has-text-info">
                 <!--   <a href="https://blog.minutemerge.com" class="navbar-item is-size-7">Blog</a>-->
                    <a href="/pricing" class="navbar-item is-size-7">Pricing</a>
                    <a href="https://app.minutemerge.com/login" class="navbar-item is-size-7">Login</a>
                    <a href="https://app.minutemerge.com/signup" class="navbar-item is-size-7 ls-main-nav--signup">Get Started</a>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
     
     

        created: function() {


document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});




        }


    }
</script>

<style lang="scss" scoped>

</style>